<div class="pointCF__content" #customFieldElement>
  <div
    class="customFieldCost"
    [class.pointCF__input--focus]="focused"
    [class.pointCF__input--disabled]="!ppCanEdit && !ppIsLocked"
    [class.pointCF__input--readonly]="ppIsLocked"
    [class.pointCF__input--integration]="
      ppIntegrationStatus === EIntegrationStatus.ON ||
      ppIntegrationStatus === EIntegrationStatus.DISABLED
    "
  >
    @if (ppFieldCurrencyCode) {
      <div
        class="customFieldNumeric__unitWrapper"
        [class.customFieldNumeric__unitWrapper--hidden]="!ppFieldCurrencyCode"
      >
        <span class="customFieldNumeric__unit" ppTooltip [ppTitle]="currencyTooltip">
          {{ ppFieldCurrencyCode }}
        </span>
      </div>
    }
    <div class="customFieldNumeric__iconWrapper">
      @if (ppCanEdit && !ppIsLocked) {
        <pp-icon
          ppTooltip
          [ppTitle]="'calculation_enabled' | ppTranslate"
          [ppSrc]="EIconPath.ICON_MISC_CALCULATOR_24"
          ppColor="grey-300"
          ppClass="setSize24"
          class="subfield__calculator__icon"
          data-test="cf-cost-calculator-icon"
        />
      }

      @if (ppIsLocked) {
        <pp-padlock-icon />
      }
    </div>

    <input
      [ppAutonumeric]="autonumericOptions"
      class="customFieldCost__input"
      data-test="cf-cost-input"
      preventPointSwitching
      [class.customFieldCost__input--noUnit]="!ppFieldCurrencyCode"
      #costInput
      [(ngModel)]="ppFieldValue"
      (ppFormatted)="updateField($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [attr.disabled]="ppIsLocked || !ppCanEdit ? true : null"
      [attr.readonly]="ppIsLocked || !ppCanEdit ? true : null"
      [attr.tabindex]="ppIsLocked || !ppCanEdit ? -1 : 0"
      [placeholder]="placeholder"
      (keydown)="onKeyDown($event)"
      (keydown.enter)="blurInput($event)"
      ppTooltip
      [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null"
    />

    <pp-save-indicator
      [ppFocused]="focused"
      [ppFilled]="ppFieldValue?.length > 0"
      [ppUpdating]="updating"
      [ppShowClearBtn]="ppCanEdit && !ppIsLocked"
      (ppAction)="clearCustomField()"
    ></pp-save-indicator>
  </div>
</div>
